import { Button } from 'primereact/button'
import { SelectButton } from 'primereact/selectbutton'

interface BooleanSelectorProps {
  label: string
  icon: string
  value: string
  onChange: (value: string, displayValue: string) => void
  onAdd: () => void
}

export const BooleanSelector: React.FC<BooleanSelectorProps> = ({
  label,
  icon,
  value,
  onChange,
  onAdd,
}) => {
  const options = [`Com ${label}`, `Sem ${label}`]

  const handleChange = (selectedValue: string) => {
    const displayValue = selectedValue?.includes('Com') ? 'Sim' : 'Não'
    const actualValue = selectedValue?.includes('Com') ? 'Yes' : 'No'
    onChange(actualValue, displayValue)
  }

  return (
    <div className='alarms-field'>
      <label htmlFor={label} className='alarms-label'>
        <i className={icon} />
        {label}
      </label>
      <SelectButton
        value={value}
        onChange={(e) => handleChange(e.value)}
        options={options}
      />
      <div className='alarms-color-section'>
        <Button
          icon='pi pi-plus'
          label='Adicionar Critério'
          onClick={onAdd}
          style={{ width: '100%' }}
          disabled={!value}
        />
      </div>
    </div>
  )
}
